import { cn } from "../../lib/utils"

const badgeVariants = (variant) => {
  const baseClasses =
    "inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2"

  switch (variant) {
    case "secondary":
      return `${baseClasses} border-transparent bg-secondary text-secondary-foreground hover:bg-secondary/80`
    case "destructive":
      return `${baseClasses} border-transparent bg-destructive text-destructive-foreground hover:bg-destructive/80`
    case "success":
      return `${baseClasses} border-transparent bg-green-600 text-white hover:bg-green-700`
    case "outline":
      return `${baseClasses} text-foreground`
    default:
      return `${baseClasses} border-transparent bg-primary text-primary-foreground hover:bg-primary/80`
  }
}

function Badge({ className, variant, ...props }) {
  return <div className={cn(badgeVariants(variant), className)} {...props} />
}

export { Badge, badgeVariants }
